import React, { useState } from 'react';

import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

// TODO: add modal to go to consent section and adjust pages to reusable components instead
// TODO: DynamicDatepickerInput focus is not working properly

const StyledDatePicker = styled(DatePicker)(({ theme, disabled }) => ({
  padding          : '0 0 0 0',
  width            : '100%',
  borderColor      : theme.palette.primary.gray15,
  '& .StyledLabel' : {
    padding   : '15px 15px 15px 50px',
    minHeight : '50px',
    width     : '100%',

    background         : disabled ? theme.palette.primary.gray4 : theme.palette.primary.white,
    backgroundRepeat   : 'no-repeat',
    backgroundPosition : '18px 50%',

    color         : theme.palette.primary.gray100,
    fontFamily    : 'Montserrat',
    fontWeight    : 400,
    fontSize      : '14px',
    fontStyle     : 'normal',
    lineHeight    : '17px',
    textTransform : 'none',
    textAlign     : 'left',
    wordWrap      : 'normal',
    opacity       : 0.8,

    borderWidth  : '1px',
    borderStyle  : 'solid',
    borderColor  : theme.palette.primary.gray15,
    borderRadius : '6px',
    position     : 'relative',

    boxSizing : 'border-box',
    resize    : 'none',
  },
  '& .MuiInputBase-root:hover' : {
    '& .MuiOutlinedInput-notchedOutline' : {
      borderColor : theme.palette.primary.blue1,
      borderWidth : '2px',
    },
    '& input' : {
      color      : theme.palette.primary.blue1,
      fontWeight : 700,
    },
    '& .MuiIconButton-root' : {
      color : theme.palette.primary.blue1
    }
  },
  '& .Mui-focused' : {
    color                                        : theme.palette.primary.blue1,
    fontWeight                                   : 700,
    '& fieldset.MuiOutlinedInput-notchedOutline' : {
      borderColor : theme.palette.primary.blue1,
      borderWidth : '2px',
    },
    '& .MuiIconButton-root' : {
      color : theme.palette.primary.blue1
    }
  },
}));

export const DynamicDatepickerInput = () => {
  const [value, setValue] = useState(null);
  const onChange = (newValue) => {
    setValue(newValue);
  };
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}>
      <StyledDatePicker
        onChange={onChange}
        value={value}
        renderInput={(params) => <TextField
          {...params}
        />}
      />
    </LocalizationProvider>
  );
};
